import type { ProjectScope } from './project-scope';

const pendingProjectionCueWriteKeys = new Set<string>();

function projectionCueWriteKey(scope: ProjectScope, cueId: string): string {
    return `${scope.orgId}/${scope.projectId}/${cueId}`;
}

export function markPendingProjectionCueWrite(scope: ProjectScope, cueId: string): void {
    pendingProjectionCueWriteKeys.add(projectionCueWriteKey(scope, cueId));
}

export function clearPendingProjectionCueWrite(scope: ProjectScope, cueId: string): void {
    pendingProjectionCueWriteKeys.delete(projectionCueWriteKey(scope, cueId));
}

export function isPendingProjectionCueWrite(scope: ProjectScope, cueId: string): boolean {
    return pendingProjectionCueWriteKeys.has(projectionCueWriteKey(scope, cueId));
}

export function clearPendingProjectionCueWrites(): void {
    pendingProjectionCueWriteKeys.clear();
}
